/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { InitialSetupInfoResponse } from '../models';
/**
 * InitialSetupInformationApi - axios parameter creator
 * @export
 */
export const InitialSetupInformationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Provides the information for initial setup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initialSetupInfo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/initialSetupInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InitialSetupInformationApi - functional programming interface
 * @export
 */
export const InitialSetupInformationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InitialSetupInformationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Provides the information for initial setup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initialSetupInfo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InitialSetupInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initialSetupInfo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InitialSetupInformationApi.initialSetupInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InitialSetupInformationApi - factory interface
 * @export
 */
export const InitialSetupInformationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InitialSetupInformationApiFp(configuration)
    return {
        /**
         * 
         * @summary Provides the information for initial setup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initialSetupInfo(options?: RawAxiosRequestConfig): AxiosPromise<InitialSetupInfoResponse> {
            return localVarFp.initialSetupInfo(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InitialSetupInformationApi - interface
 * @export
 * @interface InitialSetupInformationApi
 */
export interface InitialSetupInformationApiInterface {
    /**
     * 
     * @summary Provides the information for initial setup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InitialSetupInformationApiInterface
     */
    initialSetupInfo(options?: RawAxiosRequestConfig): AxiosPromise<InitialSetupInfoResponse>;

}

/**
 * InitialSetupInformationApi - object-oriented interface
 * @export
 * @class InitialSetupInformationApi
 * @extends {BaseAPI}
 */
export class InitialSetupInformationApi extends BaseAPI implements InitialSetupInformationApiInterface {
    /**
     * 
     * @summary Provides the information for initial setup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InitialSetupInformationApi
     */
    public initialSetupInfo(options?: RawAxiosRequestConfig) {
        return InitialSetupInformationApiFp(this.configuration).initialSetupInfo(options).then((request) => request(this.axios, this.basePath));
    }
}

